import React from 'react';
import PdfView from 'features/pdfView';

const PdfViewPage = () => {
  return <PdfView />;
};

export default PdfViewPage;
